import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

const features = [
  {
    icon: 'ri-database-2-line',
    title: '资源管理中心',
    description: '支持多格式文件上传、智能分类、全文搜索，让海量资源井井有条。',
  },
  {
    icon: 'ri-team-line',
    title: '智能协作空间',
    description: '多人实时协作，评论批注，任务分配，让团队配合天衣无缝。',
  },
  {
    icon: 'ri-bar-chart-line',
    title: '数据洞察面板',
    description: '自动收集项目数据，可视化呈现，助您做出明智决策。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全权限控制',
    description: '细粒度权限管理，加密传输存储，全方位守护数据安全。',
  },
  {
    icon: 'ri-robot-line',
    title: '智能推荐引擎',
    description: '基于行为分析的智能推荐，越用越懂您的需求。',
  },
  {
    icon: 'ri-flow-chart',
    title: '自动化工作流',
    description: '可视化编排自动化流程，释放重复劳动，提升效率。',
  },
];

const stats = [
  { value: '50,000+', label: '活跃用户' },
  { value: '99.9%', label: '服务可用性' },
  { value: '300%', label: '效率提升' },
  { value: '120+', label: '国家地区覆盖' },
];

const latestArticles = articles.slice(0, 3);

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <main>
        <Navbar />

        <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20shapes%20with%20flowing%20curves%20in%20warm%20neutral%20tones%2C%20soft%20gradient%20from%20cream%20to%20light%20gray%2C%20minimal%20modern%20design%2C%20clean%20composition%2C%20subtle%20depth%20with%20layered%20transparent%20forms%2C%20elegant%20technology%20aesthetic%2C%20no%20text&width=1800&height=900&seq=hero-bg-home&orientation=landscape"
              alt="18c.mic 平台背景"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-[1400px] mx-auto py-20">
            <div className="animate-fade-in-up">
              <span className="inline-block px-4 py-1.5 bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium rounded-full border border-background-50/20 mb-6">
                V3.0 全新发布
              </span>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 mb-6 leading-tight">
                探索18c.mic的
                <br />
                全部可能
              </h1>
              <p className="text-base md:text-lg text-background-100/80 max-w-2xl mx-auto mb-10 leading-relaxed">
                18c.mic 是您不可错过的核心平台与资源入口。深度解析功能特性、使用场景与核心价值，
                帮助您快速上手，最大化发挥平台潜力。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link
                  to="/category/guide"
                  className="whitespace-nowrap px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all cursor-pointer text-sm"
                >
                  立即开始使用
                </Link>
                <Link
                  to="/about"
                  className="whitespace-nowrap px-6 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium rounded-md border border-background-50/30 hover:bg-background-50/20 transition-all cursor-pointer text-sm"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
            <div className="text-center max-w-2xl mx-auto mb-12">
              <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
                核心功能
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                一站式的功能矩阵
              </h2>
              <p className="text-foreground-600 text-sm md:text-base">
                从资源管理到智能协作，18c.mic提供完整的工具链，助力团队高效运转。
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map((feat, i) => (
                <div
                  key={feat.title}
                  className="p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
                  style={{ animationDelay: `${i * 0.1}s` }}
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-500 transition-colors">
                    <i className={`${feat.icon} text-lg text-primary-600 group-hover:text-background-50 transition-colors`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2">
                    {feat.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {feat.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 md:gap-10">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-extrabold text-primary-600 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
            <div className="text-center max-w-2xl mx-auto mb-12">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
                内容分类
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                按需探索，精准学习
              </h2>
              <p className="text-foreground-600 text-sm md:text-base">
                五大内容分类，覆盖18c.mic的全部使用场景。
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {categories.map((cat, i) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 hover:bg-accent-50/50 transition-all cursor-pointer group text-center"
                  style={{ animationDelay: `${i * 0.1}s` }}
                >
                  <div className="w-12 h-12 mx-auto flex items-center justify-center bg-accent-100 rounded-full mb-3 group-hover:bg-accent-500 transition-colors">
                    <i className={`${cat.icon} text-xl text-accent-600 group-hover:text-background-50 transition-colors`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
            <div className="flex flex-col sm:flex-row items-center justify-between mb-12 gap-4">
              <div>
                <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-3">
                  最新资讯
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
                  热门文章推荐
                </h2>
              </div>
              <Link
                to="/category/guide"
                className="whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer flex items-center gap-1"
              >
                浏览全部文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {latestArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer group"
                >
                  <div className="w-full h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-3 text-xs text-foreground-500">
                      <span className="px-2 py-0.5 bg-primary-100 text-primary-700 rounded-full">
                        {article.category}
                      </span>
                      <span>{article.date}</span>
                      <span>{article.readTime}阅读</span>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
            <div className="relative w-full rounded-xl overflow-hidden">
              <div className="absolute inset-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20gradient%20shapes%20in%20warm%20neutral%20tones%2C%20soft%20overlapping%20curves%2C%20minimal%20modern%20design%2C%20elegant%20technology%20aesthetic%2C%20clean%20composition&width=1600&height=500&seq=cta-bg-home&orientation=landscape"
                  alt=""
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-black/20"></div>
              <div className="relative z-10 py-16 md:py-24 text-center px-4">
                <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-4">
                  准备好探索18c.mic了吗？
                </h2>
                <p className="text-background-100/80 text-sm md:text-base mb-8 max-w-lg mx-auto">
                  立即开始使用18c.mic，体验全新的资源管理与团队协作方式。
                </p>
                <Link
                  to="/category/guide"
                  className="whitespace-nowrap inline-block px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all cursor-pointer text-sm"
                >
                  免费开始使用
                </Link>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '18c.mic 官方落地页 | 探索18c.mic的全部可能',
            description: '18c.mic 核心平台与资源入口。深度解析功能特性、使用场景与核心价值。',
            url: 'https://18c.mic',
            mainEntity: {
              '@type': 'Organization',
              name: '18c.mic',
              url: 'https://18c.mic',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '18c.mic是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '18c.mic是一个核心平台与资源入口，提供资源管理、智能协作、数据分析和自动化工作流等功能。',
                },
              },
              {
                '@type': 'Question',
                name: '如何开始使用18c.mic？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '访问18c.mic官网注册账号，选择项目模板即可在5分钟内完成初始配置并开始使用。',
                },
              },
              {
                '@type': 'Question',
                name: '18c.mic适合什么规模的团队？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '18c.mic适合从个人到大型企业的各类团队，提供灵活的定价方案和可扩展的功能体系。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}